var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Gets the required settings or throws an error if they're not available
 */
export function getRequiredSettings() {
    var _a;
    if (!((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.restUrl)) {
        throw new Error('REST API URL not available. Check plugin settings.');
    }
    return {
        restUrl: window.tiofSettings.restUrl,
        restNonce: window.tiofSettings.restNonce || ''
    };
}
/**
 * Creates headers for API requests
 */
export function createHeaders() {
    var _a;
    var restNonce = getRequiredSettings().restNonce;
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-WP-Nonce': restNonce,
        'X-TIOF-Nonce': ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.nonce) || ''
    };
}
/**
 * Creates the full API URL for an endpoint
 */
export function createApiUrl(endpoint, queryParams) {
    var restUrl = getRequiredSettings().restUrl;
    // Since restUrl already includes the namespace, just append the endpoint
    var baseUrl = "".concat(restUrl, "/").concat(endpoint).replace(/([^:])\/+/g, '$1/');
    if (!queryParams) {
        return baseUrl;
    }
    var params = new URLSearchParams();
    Object.entries(queryParams).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value !== undefined && value !== null) {
            params.append(key, value);
        }
    });
    var queryString = params.toString();
    return queryString ? "".concat(baseUrl, "?").concat(queryString) : baseUrl;
}
/**
 * Makes an API request with proper error handling
 */
export function makeApiRequest(endpoint, options) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams, skipContentType, fetchOptions, url, headers, response, errorData, responseData, data, finalData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    queryParams = options.queryParams, skipContentType = options.skipContentType, fetchOptions = __rest(options, ["queryParams", "skipContentType"]);
                    url = createApiUrl(endpoint, queryParams);
                    headers = skipContentType ? {
                        'Accept': 'application/json',
                        'X-WP-Nonce': getRequiredSettings().restNonce
                    } : createHeaders();
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, fetchOptions), { headers: __assign(__assign({}, headers), fetchOptions.headers), credentials: 'same-origin' }))];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 2:
                    errorData = _a.sent();
                    return [2 /*return*/, {
                            success: false,
                            error: errorData.error || "Something went wrong: ".concat(response.status)
                        }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    responseData = _a.sent();
                    // Check if the backend explicitly set success to false
                    if (responseData.success === false) {
                        return [2 /*return*/, __assign({ success: false, error: responseData.error || 'Request failed' }, responseData // Include any additional fields like js_update, is_excluded, etc.
                            )];
                    }
                    data = responseData.data !== undefined ? responseData.data : responseData;
                    finalData = Array.isArray(data) ? data : [data];
                    return [2 /*return*/, __assign({ success: true, data: finalData }, responseData // Include any additional fields from backend
                        )];
                case 5:
                    error_1 = _a.sent();
                    return [2 /*return*/, {
                            success: false,
                            error: error_1 instanceof Error ? error_1.message : 'Unknown error occurred'
                        }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
